import React from 'react'
import { PHONE_COUNTRY_CODES, getPhoneCountryLabel } from '../data/phoneCountryCodes'

export { PHONE_COUNTRY_CODES }

const PhoneNumberInput = ({
  countryCode = '+234',
  localNumber = '',
  onCountryCodeChange,
  onLocalNumberChange,
  disabled = false,
  id = 'phoneNumber'
}) => {
  const handleLocalChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 12)
    onLocalNumberChange?.(digits)
  }

  return (
    <div className="flex gap-2">
      <select
        value={countryCode}
        onChange={(e) => onCountryCodeChange?.(e.target.value)}
        disabled={disabled}
        className="w-[42%] min-w-[7.5rem] rounded-lg border border-gray-300 bg-gray-50 px-2 py-2.5 text-base text-gray-900 focus:border-primary-600 focus:ring-primary-600 sm:text-sm"
        aria-label="Country code"
      >
        {PHONE_COUNTRY_CODES.map((item) => (
          <option key={item.iso} value={item.code}>
            {getPhoneCountryLabel(item)}
          </option>
        ))}
      </select>
      <input
        id={id}
        type="tel"
        inputMode="numeric"
        value={localNumber}
        onChange={handleLocalChange}
        disabled={disabled}
        placeholder="801 234 5678"
        maxLength={12}
        className="block min-w-0 flex-1 rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 text-base text-gray-900 focus:border-primary-600 focus:ring-primary-600 sm:text-sm"
      />
    </div>
  )
}

export default PhoneNumberInput
